// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201028/js/" + chunkId + "." + {"44":"1723ac1a","225":"9d279e7e","481":"6a7a77eb","486":"8eec82ab","770":"f58a080b"}[chunkId] + ".0.9827807597341133.chunk.js";
};